__turbopack_context__.v({
  "component": "style-module-scss-module__CLPVOG__component",
  "content": "style-module-scss-module__CLPVOG__content",
  "custom-button-style": "style-module-scss-module__CLPVOG__custom-button-style",
  "icon": "style-module-scss-module__CLPVOG__icon",
});
